<template>
  <form-item-wrapper :designer="designer" :field="field" :rules="rules" :design-state="designState"
    :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    <div :class="['datetime-box', field.options.size]" @click="onDatetimeBoxClick">
      <el-date-picker ref="date2Picker" v-model="v1" :size="field.options.size" :required="field.options.required"
        :disabled="field.options.disabled" :clearable="field.options.clearable" :class="field.options.customClass"
        :style="{ width: field.options.dateWidth }" :pickerOptions="pickerOptions" format="yyyy-MM-dd"
        value-format="yyyy-MM-dd" type="date" :placeholder="field.options.placeholder">
      </el-date-picker>
      <span class="inner-uint">|</span>
      <el-input type="text" :readonly="v1IsNull" :size="field.options.size" :required="field.options.required"
        :disabled="field.options.disabled" :clearable="false" :style="{ width: field.options.mWidth }"
        @input="(v) => (value3 = v.replace(/[^\d]/g, ''))" @blur="blurv2" :maxlength="2" v-model="v2"></el-input>
      <span class="inner-uint">时</span>
      <el-input type="text" :readonly="v1IsNull" :size="field.options.size" :required="field.options.required"
        :disabled="field.options.disabled" :clearable="false" :style="{ width: field.options.sWidth }" :maxlength="2"
        @input="(v) => (value3 = v.replace(/[^\d]/g, ''))" @blur="blurv3" v-model="v3"></el-input>
      <span class="inner-uint">分</span>
    </div>
    <input type="hidden" v-model="fieldModel" />
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n, { translate } from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import moment from "moment";
const NORM_DATE_PATTERN = "YYYY-MM-DD";
const NORM_DATETIME_PATTERN = "YYYY-MM-DD HH:mm:ss";
const NORM_DATETIME_MINUTE_PATTERN = "YYYY-MM-DD HH:mm";
function isNull(v) {
  return v === null || v === "" || v === undefined;
}
export default {
  name: "datetimeWidget",
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  components: {
    FormItemWrapper,
  },
  inject: ["refList", "globalOptionData", "globalModel"],
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],
      // 日期
      v1: null,
      // 时
      v2: null,
      // 分
      v3: null,
    };
  },
  computed: {
    v1IsNull() {
      return this.v1 === null;
    },
    pickerOptions() {
      let pickerOptions = {};
      // 禁用未来时间
      if (!!this.field.options.futureDateDisabled) {
        pickerOptions.disabledDate = function (time) {
          return time.getTime() > Date.now();
        };
      }
      // 禁用过去时间
      if (!!this.field.options.pastDateDisabled) {
        pickerOptions.disabledDate = function (time) {
          return time.getTime() < Date.now() - 1 * 24 * 60 * 60 * 1000;
        };
      }
      //只能选当天
      if (
        !!this.field.options.futureDateDisabled &&
        !!this.field.options.pastDateDisabled
      ) {
        pickerOptions.disabledDate = function (time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < Date.now() - 1 * 24 * 60 * 60 * 1000
          );
        };
      }
      //不禁用
      if (
        !this.field.options.futureDateDisabled &&
        !this.field.options.pastDateDisabled
      ) {
        pickerOptions.disabledDate = {};
      }
      return pickerOptions;
    },
  },
  watch: {
    v1(newVal) {
      // 清除日期时，将时分也清掉，保证逻辑完整性
      if (isNull(newVal)) {
        this.v2 = null;
        this.v3 = null;
        return this.changeFunc();
      }
      // 重新选择日期后，时和分默认值为0
      this.v2 = this.v2 ? String(this.v2).padStart(2, '0') : '00';
      this.v3 = this.v3 ? String(this.v3).padStart(2, '0') : '00';
      this.changeFunc();
    },
    fieldModel(newValue) {
      this.setBoxValue();
    },
  },
  beforeCreate() {
    /* 这里不能访问方法和属性！！ */
  },

  created() {
    /* 注意：子组件mounted在父组件created之后、父组件mounted之前触发，故子组件mounted需要用到的prop
         需要在父组件created中初始化！！ */
    this.registerToRefList();
    this.initFieldModel();
    this.initEventHandler();
    this.buildFieldRules();

    this.handleOnCreated();
    // 默认当前时间
    if (!this.getValue() && !!this.field.options.currentDateVisible) {
      this.fieldModel = moment().format();
    }
  },

  mounted() {
    this.handleOnMounted();
  },

  beforeDestroy() {
    this.unregisterFromRefList();
  },

  methods: {
    blurv2() {
      if (isNull(this.v2)) {
        // 小时和日期同时为空，说明清空了日期控件，则不做任何处理
        if (this.v1IsNull) {
          return;
        }
        // 小时为空且日期不为空，则赋0值
        this.v2 = 0;
        return;
      }
      // 小时不能大于23
      if (this.v2 > 23) {
        this.v2 = 23;
        // return;
      }
      this.v2 = String(this.v2).padStart(2, '0')
      this.v3 = String(this.v3).padStart(2, '0')
      // 当值是一个合法值的时候，才向父组件发出事件
      this.changeFunc();
    },
    blurv3() {
      if (isNull(this.v3)) {
        // 小时和日期同时为空，说明清空了日期控件，则不做任何处理
        if (this.v1IsNull) {
          return;
        }
        // 小时为空且日期不为空，则赋0值
        this.v3 = 0;
        return;
      }
      // 分钟不能大于59
      if (this.v3 > 59) {
        this.v3 = 59
        return
      }
      this.v2 = String(this.v2).padStart(2, '0')
      this.v3 = String(this.v3).padStart(2, '0')
      // 当值是一个合法值的时候，才向父组件发出事件
      this.changeFunc();
    },
    changeFunc() {
      let temp = `${moment(this.v1).format(NORM_DATE_PATTERN)} ${this.v2}:${this.v3
        }`;
      let datetime = moment(temp);
      let datetimeStr = null;
      if (datetime.isValid()) {
        datetimeStr = datetime.format(this.field.options.valueFormat);
      }
      // 事件节流
      if (this.getValue() === datetimeStr) {
        return;
      }
      this.fieldModel = datetimeStr;
      this.dispatch("ElFormItem", "el.form.change", [datetimeStr]);
      this.handleChangeEvent(datetimeStr);
      this.handleBlurCustomEvent(datetimeStr);
    },
    setBoxValue() {
      if (this.getValue()) {
        let datetime = moment(this.getValue());
        if (!datetime.isValid()) {
          return;
        }
        this.v1 = datetime.format(NORM_DATE_PATTERN);
        this.v2 = String(datetime.hours()).padStart(2, '0');
        this.v3 = String(datetime.minutes()).padStart(2, '0')
      } else {
        // 重置表单
        this.v1 = null;
        this.v2 = null;
        this.v3 = null;
      }
    },
    onDatetimeBoxClick() {
      if (this.v1IsNull) {
        this.$refs.datePicker.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/global.scss"; //* form-item-wrapper已引入，还需要重复引入吗？ *//

.full-width-input {
  width: 100% !important;
}

.datetime-box {
  display: flex;
  align-items: center;
  border: 1px solid #c5c5c5;
  padding-left: 1px;
  box-sizing: border-box;
}

::v-deep .el-form-item--mini {
  .el-input__inner {
    height: 23px;
    line-height: 23px;
  }

  .datetime-box {
    height: 28px;
  }
}

::v-deep .el-form-item--small {
  .el-input__inner {
    height: 29px;
    line-height: 29px;
  }

  .datetime-box {
    height: 32px;
  }
}

::v-deep .el-form-item--medium {
  .el-input__inner {
    height: 33px;
    line-height: 33px;
  }

  .datetime-box {
    height: 36px;
  }
}

::v-deep .el-form-item--large {
  .el-input__inner {
    height: 37px;
    line-height: 37px;
  }

  .datetime-box {
    height: 40px;
  }
}

.datetime-box.mini {
  max-height: 28px;

  ::v-deep .el-input__inner {
    height: 23px;
    line-height: 23px;
  }
}

.datetime-box.small {
  max-height: 32px;

  ::v-deep .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
}

.datetime-box.medium {
  max-height: 36px;

  ::v-deep .el-input__inner {
    height: 33px;
    line-height: 33px;
  }
}

.datetime-box.large {
  max-height: 40px;

  ::v-deep .el-input__inner {
    height: 37px;
    line-height: 37px;
  }
}

.datetime-box ::v-deep .el-input__inner {
  border: none;
}

::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.inner-uint {
  color: #9c9c9c;
  padding-right: 2px;
  text-align: right;
  display: inline-block;
}

.el-form-item.is-error .datetime-box {
  border-color: #f56c6c;
}
</style>
